import * as React from "react";
import {Col, Row} from "react-bootstrap";
import {KContainer, KSpace} from "@kopjra/uikit"
import {Acquisitions} from "./Acquisitions.tsx";

export const AcquisitionArea: React.FC = () => {
    return (
        <KContainer>
            <KSpace spaces={2}/>
            <Row>
                <Col xs={12}><Acquisitions reduced={false}/></Col>
            </Row>
        </KContainer>
    );
};